
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Pop from "@/views/ai-builder/components/blue-pop.vue";
import UploadImgBefore from "@/components/UploadImg-ai.vue";
import {
  Company,
  CompanySpecialConfigNew
} from "@/lib/model/exambuilder/exam-component/company";

@Component({
  components: { Pop, UploadImgBefore }
})
export default class V15Config extends Vue {
  hasChange = false;

  configV15 = new CompanySpecialConfigNew();

  //获取公司背景
  getBgImg() {
    Company.get().then((res: any) => {
      this.configV15 = res.companySpecialConfigNew;
    });
  }

  mounted() {
    this.getBgImg();
  }

  uploadedBeforeImg(imgUrl: string) {
    this.hasChange = true;
    this.configV15.loginBgUrl = imgUrl;
  }
  submit() {
    Company.update({ companySpecialConfigNew: this.configV15 }).then(() => {
      //
      this.$message.success("保存成功");
    });
  }
}
